// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NsAa","link":"_2ygnQ","term":"_3sBUr"};